import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap, switchMap, flatMap } from 'rxjs/operators';

import { LeaveRequestService } from '../leave-request.service';
import { ResponseStatus } from '../../shared';
import * as LeaveRequestActions from './leave-request.actions';
import * as fromShared from '../../shared';

@Injectable()
export class LeaveRequestEffects {
    getLeaveRequests$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(LeaveRequestActions.getLeaveRequests),
            switchMap(a =>
                this.service
                    .get(a.userId, a.userRole, a.startDate, a.endDate)
                    .pipe(
                        map(data =>
                            LeaveRequestActions.loadLeaveRequests({
                                leaveRequests: data
                            })
                        ),
                        catchError(fromShared.Errors.handleServiceError)
                    )
            )
        );
    });

    putLeaveRequests$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(LeaveRequestActions.putLeaveRequests),
            switchMap(a =>
                this.service.put(a.requests).pipe(
                    concatMap(resp =>
                        fromShared.Errors.IsSuccessStatus(resp.StatusCode)
                            ? [
                                  LeaveRequestActions.upsertLeaveRequests({
                                      leaveRequests: resp.Items
                                  }),
                                  new fromShared.Errors.RemoveErrors(
                                      resp.Items.filter(
                                          i =>
                                              i.Status.StatusCode ===
                                              ResponseStatus.Success
                                      ).map(i => i.AuthRequestID.toString())
                                  )
                              ]
                            : [
                                  new fromShared.Errors.SetErrors(
                                      fromShared.Errors.MapErrorsToStatus(resp)
                                  ),
                                  LeaveRequestActions.upsertLeaveRequests({
                                      leaveRequests: resp.Items
                                  })
                              ]
                    ),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });

    deleteLeaveRequests$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(LeaveRequestActions.deleteLeaveRequests),
                switchMap(a =>
                    this.service
                        .delete(a.ids.map(x => ({ AuthRequestID: x })))
                        .pipe(
                            flatMap(resp =>
                                fromShared.Errors.IsSuccessStatus(
                                    resp.StatusCode
                                )
                                    ? [
                                          LeaveRequestActions.deleteLeaveRequestsSuccess(
                                              { ids: a.ids }
                                          ),
                                          new fromShared.Errors.RemoveErrors(
                                              resp.Items.filter(
                                                  i =>
                                                      i.Status.StatusCode ===
                                                      ResponseStatus.Success
                                              ).map((i: any) => i.EntityID)
                                          )
                                      ]
                                    : [
                                          new fromShared.Errors.SetErrors(
                                              fromShared.Errors.MapErrorsToStatus(
                                                  resp
                                              )
                                          )
                                      ]
                            ),
                            catchError(fromShared.Errors.handleServiceError)
                        )
                )
            );
        },
    );

    constructor(
        private actions$: Actions,
        private service: LeaveRequestService
    ) {}
}
